import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for Pick a Look (/looks). Anchors live in PickALookPage.tsx. */
export function getPickALookTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Pick a Look',
        description:
          'Choose a layout for each part of your site — mix and match as you like. Your choices ' +
          'save to your draft, so publish your site when you’re ready for visitors to see them.',
      },
    },
    {
      element: at('looks-dark'),
      popover: {
        title: 'Dark mode',
        description:
          'Turn this on to show your whole site on a dark background. It works with any look, and ' +
          'your brand color stays the same.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('looks-hero'),
      popover: {
        title: 'Hero height',
        description:
          'Choose how tall the big banner at the top of your home page is: Current, Tall, Very ' +
          'tall, or Full screen.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('looks-home'),
      popover: {
        title: 'Choose a home page look',
        description:
          'Click a card to use that layout — Classic is the built-in one. Each card is a live mini ' +
          'preview; hover and click “Preview” to see it full size in a new tab. Some looks come ' +
          'with their own colors and fonts, and you’ll be asked whether to use them or keep yours.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('looks-search'),
      popover: {
        title: 'More pages to style',
        description:
          'Keep scrolling to pick looks for your Search, Listing Display, Community, and Blog pages ' +
          'the same way. The bar at the top jumps you to each one.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
